<template>
    <g clip-path="url(#clip0_1332_4736)">
        <path
            d="M19.6066 5.3162L15.4634 1.39651C15.0227 0.979582 14.4459 0.75 13.8392 0.75H5.95117C4.64806 0.75 3.58789 1.81017 3.58789 3.11328V20.3867C3.58789 21.6898 4.64806 22.75 5.95117 22.75H17.9824C19.2855 22.75 20.3457 21.6898 20.3457 20.3867V7.03298C20.3457 6.38634 20.0763 5.76059 19.6066 5.3162ZM18.3546 5.90625H15.1465C15.028 5.90625 14.9316 5.80987 14.9316 5.69141V2.66795L18.3546 5.90625ZM17.9824 21.4609H5.95117C5.35885 21.4609 4.87695 20.979 4.87695 20.3867V3.11328C4.87695 2.52096 5.35885 2.03906 5.95117 2.03906H13.6426V5.69141C13.6426 6.52066 14.3172 7.19531 15.1465 7.19531H19.0566V20.3867C19.0566 20.979 18.5747 21.4609 17.9824 21.4609Z"
        />
        <path
            d="M16.5645 9.34375H7.11133C6.75537 9.34375 6.4668 9.63233 6.4668 9.98828C6.4668 10.3442 6.75537 10.6328 7.11133 10.6328H16.5645C16.9204 10.6328 17.209 10.3442 17.209 9.98828C17.209 9.63233 16.9204 9.34375 16.5645 9.34375Z"
        />
        <path
            d="M16.5645 12.7812H7.11133C6.75537 12.7812 6.4668 13.0698 6.4668 13.4258C6.4668 13.7817 6.75537 14.0703 7.11133 14.0703H16.5645C16.9204 14.0703 17.209 13.7817 17.209 13.4258C17.209 13.0698 16.9204 12.7812 16.5645 12.7812Z"
        />
        <path
            d="M10.236 16.2188H7.11133C6.75537 16.2188 6.4668 16.5073 6.4668 16.8633C6.4668 17.2192 6.75537 17.5078 7.11133 17.5078H10.236C10.592 17.5078 10.8805 17.2192 10.8805 16.8633C10.8805 16.5073 10.592 16.2188 10.236 16.2188Z"
        />
    </g>
    <defs>
        <clipPath id="clip0_1332_4736">
            <rect width="22" height="22" fill="white" transform="translate(0.966797 0.75)" />
        </clipPath>
    </defs>
</template>
